module.exports = __webpack_public_path__ + "static/media/map_pointer.4a706b6d.svg";